const LoadingImage = () => {
	return (
		<svg
			width="246"
			height="148"
			fill="none"
			preserveAspectRatio="none"
			viewBox="0 0 246 150"
		>
			<g clipPath="url(#ea11y-loader-a)">
				<path fill="#f2f2f2" d="M3.918 15.467h238.398v130.962H3.918z" />
				<g clipPath="url(#ea11y-loader-b)">
					<animateMotion
						fill="freeze"
						calcMode="spline"
						dur="3s"
						keyPoints="0; 0; 1; 1"
						keySplines="0.42 0 1 1; 0 0 1 1; 0 0 1 1"
						keyTimes="0; 0.25; 0.666667; 1"
						path="M 0 0 L -0.094 -114.83"
						repeatCount="indefinite"
					/>
					<g transform="matrix(1.26558 0 0 1 -3.316 78)">
						<rect
							width="108.675"
							height="5.72"
							x="12.486"
							y="36.785"
							fill="#d7d7d7"
							rx="2.86"
						/>
						<rect
							width="62.202"
							height="5.72"
							x="12.486"
							y="48.225"
							fill="#d7d7d7"
							rx="2.86"
						/>
					</g>
					<rect
						width="62.694"
						height="95.75"
						x="169.928"
						y="36.119"
						fill="#d7d7d7"
						rx="6.33"
						ry="6.33"
						transform="matrix(1 0 .00236 1 -.199 .267)"
					/>
					<rect
						width="137.561"
						height="68.877"
						x="12.493"
						y="36.705"
						fill="#d7d7d7"
						rx="6.274"
					/>
				</g>
				<g clipPath="url(#ea11y-loader-b)" transform="translate(0 118)">
					<g transform="matrix(1.26558 0 0 1 -3.316 78)">
						<rect
							width="108.675"
							height="5.72"
							x="12.486"
							y="36.785"
							fill="#d7d7d7"
							rx="2.86"
						/>
						<rect
							width="62.202"
							height="5.72"
							x="12.486"
							y="48.225"
							fill="#d7d7d7"
							rx="2.86"
						/>
					</g>
					<rect
						width="62.694"
						height="95.75"
						x="169.928"
						y="36.119"
						fill="#d7d7d7"
						rx="6.33"
						ry="6.33"
						transform="matrix(1 0 .00236 1 -.199 .267)"
					/>
					<rect
						width="137.561"
						height="68.877"
						x="12.493"
						y="36.705"
						fill="#d7d7d7"
						rx="6.274"
					/>
					<animateMotion
						fill="freeze"
						calcMode="spline"
						dur="3s"
						keyPoints="0; 0; 1; 1"
						keySplines="0.42 0 0.58 1; 0 0.55 0.45 1; 0 0 1 1"
						keyTimes="0; 0.6; 0.9; 1"
						path="M 0 0 L -0.094 -117.848"
						repeatCount="indefinite"
					/>
				</g>
			</g>
			<g
				style={{ transformOrigin: '123px 90.305px 0' }}
				transform="translate(.002 -93.01)"
			>
				<path fill="url(#c)" d="M3.998 69.01h238.4v42.49H3.998z" />
				<path
					fill="#2c73ff"
					d="m4.007 110.27 238.393-.06s0 1.4.007 1.389c0 0-238.315-.044-238.39-.121"
				/>
				<animateMotion
					fill="freeze"
					begin="0.02s"
					calcMode="linear"
					dur="3s"
					keyPoints="0; 0.53; 1"
					keyTimes="0; 0.49333; 1"
					path="M 0 0 L -1.038 173.378"
					repeatCount="indefinite"
				/>
			</g>
			<path
				fill="#000"
				d="M3.9 2.575A2.576 2.576 0 0 1 6.477 0h233.245a2.58 2.58 0 0 1 2.578 2.575v14.263H3.9z"
			/>
			<circle cx="14.945" cy="8.369" r="3.863" fill="#fff" />
			<circle cx="25.888" cy="8.369" r="3.863" fill="#fff" />
			<circle cx="36.832" cy="8.369" r="3.863" fill="#fff" />
			<defs>
				<clipPath id="ea11y-loader-a">
					<path
						fill="#fff"
						d="M3.918 16.467h238.398V140.37a7.06 7.06 0 0 1-7.058 7.058H10.976a7.06 7.06 0 0 1-7.058-7.058z"
					/>
				</clipPath>
				<clipPath id="ea11y-loader-b">
					<path fill="#fff" d="M3.918 16.467h238.398v130.962H3.918z" />
				</clipPath>
				<linearGradient
					id="c"
					x1="116.833"
					x2="116.833"
					y1="69.01"
					y2="111.501"
					gradientTransform="matrix(1.00081 0 0 1 -.003 0)"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#2c73ff" stopOpacity="0" />
					<stop offset="1" stopColor="#2c73ff" stopOpacity=".7" />
				</linearGradient>
			</defs>
		</svg>
	);
};

export default LoadingImage;
